import { useQuery } from "@tanstack/react-query";
import { EMPLOYEE_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

const getDeactivationImpact = async (id: string) => {
  if (!id) return null;
  return await axiosAuth.get(`${EMPLOYEE_API}/${id}/deactivation-impact`);
};

export interface DeactivationImpact {
  hasActiveAssignments: boolean;
  activeProjectAssignments: Array<{
    projectName: string;
    roleName: string;
  }>;
}

const useGetDeactivationImpact = ({ id, queryParams }: { id: string; queryParams?: any }) =>
  useQuery<any, any, DeactivationImpact>({
    queryKey: ["deactivation-impact", id],
    queryFn: () => getDeactivationImpact(id),
    select: (data: any) => data?.data?.data,
    enabled: !!id,
    ...queryParams,
  });

export default useGetDeactivationImpact;
